import Destination from './containers/Destination';

export default Destination;
